'use client'

import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import { useParams, usePathname } from 'next/navigation'
import { useTranslation } from 'react-i18next'

const SolutionsPageComponent = () => {
  const { t } = useTranslation()
  const pathName = usePathname()
  const [activeSubscription, setActiveSubscription] = useState<string>('')
  const {lng}=useParams<{lng:string}>()
  useEffect(() => {
    setActiveSubscription(pathName.split('/').pop() || '')
  }, [pathName])

  return (
    <div>
      <div className="flex justify-center mobile-width">
        <div className="w-[1280px] flex flex-col items-center my-[80px] mobile-width mobile:mt-[10px] mobile:mb-[0px]">
          <h6 className="text-base font-ns_bold text-primary">
            {t('Subscriptions')}
          </h6>
          <h1 className="text-4xl font-ns_bold mt-[5px] mobile:text-center mobile:text-[18px]">
            {t('Set up your site, pick a plan alter')}
          </h1>
          <p className="w-[460px] text-base text-center mt-[17px] mobile-width mobile:text-center mobile:mt-[0px]">
            {t(
              'Simple plans. Simple prices. Only pay for what you really need. All plans come with exciting features'
            )}
          </p>

          <div className="mt-[40px] mobile:mt-[20px]">
            <ul className="flex px-[54px] h-[52px] shadow-[0_1px_6px_0_rgba(0,0,0,0.16)] gap-[60px] mobile:gap-[20px] mobile-width mobile:px-[5px] mobile:justify-around">
              <li
                className={`text-[#767676] text-[18px] font-bold h-full flex items-center cursor-pointer mobile:text-nowrap mobile:text-[14px] ${
                  activeSubscription === 'for_buyers'
                    ? 'text-orange border-b-2 border-b-orange border-solid'
                    : ''
                }`}
                onClick={() => setActiveSubscription('for_buyers')}
              >
                <Link href={`/${lng}/solutions/for_buyers`}>{t('For Buyer')}</Link>
              </li>
              <li
                className={`text-[#767676] text-[18px] font-bold flex items-center cursor-pointer mobile:text-nowrap mobile:text-[14px] ${
                  activeSubscription === 'for_sellers'
                    ? 'text-orange border-b-2 border-b-orange border-solid'
                    : ''
                }`}
                onClick={() => setActiveSubscription('for_sellers')}
              >
                <Link href={`/${lng}/solutions/for_sellers`}>{t('For Seller')}</Link>
              </li>
              <li
                className={`text-[#767676] text-[18px] font-bold flex items-center cursor-pointer mobile:text-nowrap mobile:text-[14px] ${
                  activeSubscription === 'for_prepost_harvest'
                    ? 'text-orange border-b-2 border-b-orange border-solid'
                    : ''
                }`}
                onClick={() => setActiveSubscription('for_prepost_harvest')}
              >
                <Link href={`/${lng}/solutions/for_prepost_harvest`}>
                  {t('For Pre-Post Harvest')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SolutionsPageComponent
